
// @ts-nocheck
/* 
 * This file has type checking disabled to prevent the TS2589 error:
 * "Type instantiation is excessively deep and possibly infinite"
 * which occurs due to complex type inference with the Supabase client.
 */

import { useState, useEffect } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { toast } from '@/components/ui/use-toast';
import type { FlatTourData } from '@/utils/tourTransformUtils';
import { fetchPublicTours } from '@/services/tour/fetchPublicTours'; 

export type { FlatTourData } from '@/utils/tourTransformUtils';

export function useToursData() {
  const { t, language } = useLanguage();
  const [tours, setTours] = useState<FlatTourData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [rawResponse, setRawResponse] = useState<any>(null);

  useEffect(() => {
    const loadTours = async () => {
      try {
        setLoading(true);
        console.log(`[useToursData] Fetching tours for language: ${language}`);
        
        // Use our dedicated service function to fetch public tours
        const toursWithExhibitCounts = await fetchPublicTours(language);
        
        if (toursWithExhibitCounts.length === 0) {
          console.warn('[useToursData] WARNING: No tours returned from database');
          console.warn('[useToursData] This could indicate RLS policies preventing access');
        }
        
        setTours(toursWithExhibitCounts);
      } catch (err) {
        console.error('[useToursData] Error loading tours:', err);
        setError(err instanceof Error ? err : new Error('Unknown error'));
        toast({
          title: t('error'),
          description: t('error_loading_tours'),
          variant: "destructive",
        });
      } finally {
        setLoading(false);
      }
    };
    
    loadTours();
  }, [language, t]);

  return { tours, loading, error, rawResponse };
}
